import { ScreenConstants } from "../constants/screens";
import { SecondaryScreenLayout } from "../interfaces/secondaryScreens";

const getColumnPlayers = (column: SecondaryScreenLayout["columns"][0]) => {
  return {
    columns: column.playerColumns ?? ScreenConstants.DefaultPlayersColumnsPerLayoutColumn * column.width,
    rows: column.playerRows ?? ScreenConstants.DefaultPlayersRowsPerLayoutColumn,
  };
}

export const ScreenHelpers = {
  getColumnPlayers,
};